var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 32,
    height: 15,
    rx: 2,
    fill: "#26B634"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83 23L10.8 20.24L12.77 23H14.12L11.5 19.39L13.97 16H12.62L10.8 18.53L8.98 16H7.63L10.09 19.39L7.48 23H8.83ZM14.9516 16V23H19.7716V21.94H16.0916V16H14.9516ZM20.3921 17.78C20.3921 20.26 24.3921 19.6 24.3921 21.22C24.3921 21.88 23.7221 22.09 22.8221 22.09C22.0221 22.09 21.1821 21.89 20.4221 21.4V22.52C21.1121 22.91 21.9621 23.13 22.9021 23.13C24.3021 23.14 25.5521 22.63 25.5521 21.16C25.5521 18.66 21.5521 19.27 21.5521 17.76C21.5521 17.16 22.0921 16.91 22.9421 16.91C23.6921 16.9 24.4721 17.11 25.0421 17.49V16.4C24.4721 16.07 23.6521 15.87 22.8521 15.87C21.5321 15.87 20.3921 16.49 20.3921 17.78ZM27.1308 23L29.1008 20.24L31.0708 23H32.4208L29.8008 19.39L32.2708 16H30.9208L29.1008 18.53L27.2808 16H25.9308L28.3908 19.39L25.7808 23H27.1308Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.3962ac4822edbdf5a9618de0b2873462.svg";
export { ForwardRef as ReactComponent };